<template>
  <v-container class="searchItemContainer">    
    <v-row>
      <v-col sm="6" md="6" lg="7" class="searchItemColLeft">        
        <v-text-field
              v-model="itemValueLocal.value"
              height="30"
              solo
              class="searchItemHeight"
              :placeholder="label"
            ></v-text-field>
      </v-col>
      <v-col sm="6" md="6" lg="5" class="searchItemColRight">
        <v-select
          v-model="itemValueLocal.valueType"
          :items="selectType"
          item-value="value"
          item-text="text"
          solo
          class="searchItemHeight"
        ></v-select>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import router from "@/router/index.js";
import { Trans } from "@/plugins/Translation";


export default {
  props: {
    label: "",
    itemValue: { value: {type: String, default: ""}, valueType: {type: String, default: "StartWith"}}
  },

  components: {  },

  data: () => ({
    // itemValue: "",    
    defaultValue: {},
    selectType: [
      {
        text: "Equal",
        value: "Equal"
      },
      {
        text: "StartWith",
        value: "StartWith"
      },
      {
        text: "Contains",
        value: "Contains"
      },      
      {
        text: "NotEqual",
        value: "NotEqual"
      },
      {
        text: "NotContains",
        value: "NotContains"
      }
    ],
    loading: false
  }),

  watch: {},

  computed: {
    itemValueLocal: {
            get: function() {                
                return this.itemValue
            },
            set: function(value) {              
                this.$emit('itemValueChange', value)                
            }
    }
  },

  methods: {
      getValues() {      
      
      let res = {
        type: this.defaultValue,
        value: this.itemValue
      }
    
      return res;
    },

    setValues(type, value) {
      this.defaultValue = type;
      this.itemValue = value;      
    },
  },
  
  created() {    
  }
}
</script>